import React from 'react';

import EoTResultSummary from './EoTResultSummary'
import UserInfo from '../UserInfo'
import Toggle from '../Toggle'

var diceTypes = ['ability', 'proficiency', 'boost',
                 'difficulty', 'challenge', 'setback',
                 'force',
                 'advantage', 'black', 'despair', 'fail',
                 'success', 'threat', 'triumph', 'white'
                 ];

var diceDisplayKey = 0;

var EoTResult = ({ result, toggleCallback, forceToggleClear }) => {
  var display = [];

  var diceFaceStyle = {
    maxHeight: 24,
    marginRight: 2
  }

  diceTypes.forEach(diceType => {
    if (result[diceType]) {
      result[diceType].forEach(diceFace => {
        var imgSrc = `/diceImages/eot/diceFaces/${diceType}/${diceType}`;
        if (diceFace.length > 0) {
          imgSrc += `-${diceFace}`;
        }
        imgSrc += '.png';

        display.push(<img style={diceFaceStyle} key={diceDisplayKey++} src={imgSrc} alt={diceType}  />);
      })
    }
  });

  var numberFaceStyle = {
    height: 24,
    minWidth: 24,
    padding: '0 2px',
    lineHeight: '22px',
    boxSizing: 'border-box',
    backgroundColor: '#eee',
    border: '1px solid #CCC',
    marginRight: 3,
    fontSize: 14,
    display: 'inline-block',
    textAlign: 'center',
    verticalAlign: 'top',
  }

  if (result.random) {
    result.random.forEach(randomRoll => {
      display.push(<span style={numberFaceStyle} key={diceDisplayKey++}>{randomRoll}</span>)
    })
  }

  var resultStyle = {
    display: 'inline-block',
    verticalAlign: 'top',
    minHeight: 48,
    // marginLeft:  10,
    paddingLeft: 10,
    // borderLeft: '1px solid #ccc'
  }

  var rowStyle = {
    marginBottom: 5,
    paddingBottom: 5,
    borderBottom: '1px solid #ccc'
  }

  var captionStyle = (result.caption && result.caption.length > 0) ?
    {
      fontSize: '0.8em',
      lineHeight: '24px',
      verticalAlign: 'top',
    } : {
      display: 'none'
    }

  var toggleChange = function(isClicked) {
    toggleCallback(isClicked, result);
  }

  var userInfo;
  if (toggleCallback) {
    userInfo = (<Toggle forceClear={forceToggleClear} onChange={toggleChange}>
          <UserInfo user={result.user} />
        </Toggle>)
  } else {
    userInfo = <UserInfo user={result.user} />
  }

  return (
    <div className="EoTResultRow" style={rowStyle}>
      <div style={{display: 'inline-block'}}>
        {userInfo}
      </div>
      <div className="results" style={resultStyle}>
        {display} <span style={captionStyle}>{result.caption}</span>
        <EoTResultSummary result={result}/>
      </div>
    </div>
  )
}

export { diceTypes }

export default EoTResult;


// WEBPACK FOOTER //
// ./src/RollResults/EoT/EoTResult.js